import { CABINET_DRAFT_ENABLED } from '@/config/draft-enabled';

/**
 * useDraftEnabled — кит компонентов (WEB-3738): включён ли черновик кабинета.
 *
 * Черновое — то, чего ещё нет на сервере: в эталоне рескина оно обёрнуто
 * `IfDraft` / `DraftOnly` (`../web2app-spec/design/cabinet-rescin/kit-draft.jsx`).
 * Флаг — переменная сборки `VITE_CABINET_DRAFT` (`config/draft-enabled.ts`):
 * на стенде и локально `true`, на бою переменной нет — выключен. Переключения на
 * ходу (как «Демо» эталона) нет: флаг вшит в сборку.
 *
 * Для условий внутри разделов; целый кусок прячут `IfDraft` и `DraftOnly`.
 *
 * Подмена в тестах — один способ: `jest.mock` модуля `@/config/draft-enabled`.
 *   jest.mock('@/config/draft-enabled', () => ({ CABINET_DRAFT_ENABLED: true }));
 * Без подмены jest отдаёт `src/__mocks__/draftEnabled.ts` — флаг выключен, как
 * на бою. Нужны оба положения в одном наборе — геттер в фабрике подмены
 * (образец — `components/kit/IfDraft.test.tsx`).
 */
export function useDraftEnabled(): boolean {
  return CABINET_DRAFT_ENABLED;
}
